import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Routes as RouterRoutes, Route } from "react-router-dom";
import { HomeScreen } from "./screens/home-screen/home-screen";
import { LinksScreen } from "./screens/links-screen/links-screen";
import { AccessCodeScreen } from "./screens/access-code-screen/access-code-screen";
import { NotificationsScreen } from "./screens/notifications-screen/notifications-screen";
export function Routes() {
    return (_jsxs(RouterRoutes, { children: [_jsx(Route, { path: "/", element: _jsx(HomeScreen, {}) }), _jsx(Route, { path: "/links", element: _jsx(LinksScreen, {}) }), _jsx(Route, { path: "/access-code", element: _jsx(AccessCodeScreen, {}) }), _jsx(Route, { path: "/notifications", element: _jsx(NotificationsScreen, {}) }), _jsx(Route, { path: "*", element: _jsx(HomeScreen, {}) })] }));
}
